require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-jakub-jedryszek.json") })
        }
      }, "path---blog-author-jakub-jedryszek");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-jakub-jedryszek!./.cache/json/blog-author-jakub-jedryszek.json
// module id = 651
// module chunks = 231608221292675